import { z } from "zod";

export const zAttrLink = z.object({
  editor: z.literal("Link"),
});

export type ZAttrLink = z.infer<typeof zAttrLink>;
